{
  "accountRole": "Account role",
  "accountRoles": {"administrator": "Administrator", "member": "Member"},
  "avatar": {
    "cancel": "Cancel",
    "change": "Change picture",
    "choose": "Choose a picture",
    "cropArea": "The part of your picture that shows",
    "cropHint": "Drag the picture, or use the arrow keys, to choose the part that shows.",
    "hint": "Shown wherever your name is. Without one, a pattern made for you stands in.",
    "loading": "Opening the picture…",
    "remove": "Remove picture",
    "save": "Save picture",
    "title": "Picture",
    "unreadable": "This file isn't a picture your browser can open.",
    "zoom": "Zoom"
  },
  "connections": {
    "callback": {
      "denied": "Nothing was connected: the authorization was cancelled or did not come back complete.",
      "title": "Connecting",
      "working": "Finishing the connection…"
    },
    "connect": "Connect {{provider}}",
    "connectAgain": "Connect {{provider}} again",
    "connectedAs": "Connected as {{login}}.",
    "disconnect": "Disconnect",
    "disconnectHint": "Disconnecting stops it at once: sources you imported through it are not fetched any more. What DMW has already copied stays.",
    "disconnected": {
      "failed": "Disconnected in DMW. {{provider}} did not confirm, so withdraw DMW's App in your {{provider}} settings under Applications.",
      "revoked": "Disconnected. {{provider}} has withdrawn DMW's access too.",
      "unsupported": "Disconnected in DMW. Withdraw DMW's access in your {{provider}} settings as well."
    },
    "install": "Install DMW's App on repositories",
    "installHint": "DMW reads only the repositories you install its App on, and only reads them.",
    "needsReconnect": "{{provider}} no longer accepts this connection.",
    "notConnected": "Not connected.",
    "off": {
      "not_configured": "Not set up on this server. Ask your administrator.",
      "secret_unreadable": "Not set up: the server cannot read the connection's secrets. Ask your administrator.",
      "vault_off": "Not set up: the server has no key to keep tokens encrypted. Ask your administrator."
    },
    "title": "Connections"
  },
  "displayName": "Name",
  "email": "Email",
  "helpView": {"newTab": "In a new tab", "opens": "Help opens", "samePage": "In place of the page"},
  "logout": "Sign out",
  "memories": {
    "personalPolicy": "Agents may save memories",
    "policies": {"confirm": "Ask me first", "keep": "Keep at once", "off": "May not save"}
  },
  "pages": {
    "account": "Account",
    "connectors": "Connect this PC",
    "label": "Profile pages",
    "memories": "My memories",
    "preferences": "Personal preferences"
  },
  "personalPermissions": "Which tools may run on your PC, and what agents may do there, is set on that PC: in your DMW Connector's permission profile, and when a Run asks you. See",
  "reasoningLevel": "Reasoning effort: {{agent}}",
  "signUpEmails": {
    "hint": "An email for each new sign-up, when this installation sends email.",
    "label": "Emails about sign-ups",
    "off": "Don't send",
    "on": "Send them"
  },
  "threadView": {
    "autoSettle": "Settle inactive Runs after",
    "autoSettleChoices": {
      "off": "Never",
      "one_day": "1 day",
      "one_month": "1 month",
      "one_week": "1 week",
      "three_days": "3 days"
    },
    "condensed": "Condensed",
    "detailed": "Detailed",
    "hidden": "Hidden",
    "toolCalls": "Tool calls in Runs"
  },
  "title": "Profile",
  "workflowView": {
    "density": "Process schema cards",
    "densityHint": "The default for a process schema page; its toolbar changes that page only.",
    "layout": "Process schema graph direction"
  }
}
